import React from "react";
import styled from "styled-components";

import Button from "@ingka/button";
import Toast from "@ingka/toast";
import Modal, { Prompt } from "@ingka/modal";

import AddFeedbackModal from "./AddFeedbackModal";
import { SrOnly, StyledModalHeader } from "../styles";
import Ratings from "./Ratings";

const StyledWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 0.5rem;
	flex-wrap: wrap;
	margin-bottom: 2rem;
`;

const StyledModal = styled(Modal)`
	.prompt {
		width: 25rem;
	}

	.modal-footer {
		padding: 1rem;
	}
`;

interface FeedbackLayoutProps {
	showFeedbackModal: boolean;
	setShowFeedbackModal: (val: boolean) => void;
	showAddFeedbackModal: boolean;
	setShowAddFeedbackModal: (val: boolean) => void;
	sendFeedback: () => void;
	setFeedbackScore: (val: number) => void;
	setFeedbackPage: (val: string) => void;
	feedbackText: string;
	setFeedbackText: (val: string) => void;
	sendFeedbackLoading: boolean;
	toastMessage: string;
	setToastMessage: (val: string) => void;
	isAdmin: boolean;
	setShowModalFromFloatingMenu?: (val: boolean) => void;
	showRating: boolean;
	feedbackScore: number;
	feedbackPage: string;
	feedbackCategories: string[];
	onRating: (rating: number) => void;
}

const Layout: React.FC<FeedbackLayoutProps> = ({
	showFeedbackModal,
	setShowFeedbackModal,
	showAddFeedbackModal,
	setShowAddFeedbackModal,
	sendFeedback,
	setFeedbackPage,
	feedbackText,
	setFeedbackText,
	sendFeedbackLoading,
	toastMessage,
	setToastMessage,
	setShowModalFromFloatingMenu,
	showRating,
	feedbackCategories,
	feedbackScore,
	feedbackPage,
	onRating,
}) => {
	return (
		<>
			{showRating && <Ratings onRatings={onRating} rating={feedbackScore} />}
			<StyledModal visible={showFeedbackModal} escapable={true} handleCloseBtn={() => setShowFeedbackModal(false)}>
				<Prompt
					title="Help us, what can we do better?"
					titleId="modalTitleId"
					footer={null}
					header={<StyledModalHeader />}
				>
					<StyledWrapper role="group">
						{feedbackCategories.map((linkText, index) => (
							<Button
								key={index}
								aria-selected={feedbackPage === linkText}
								aria-haspopup="dialog"
								size="small"
								data-autofocus={index === 0}
								onClick={() => {
									setFeedbackPage(linkText);
									setShowFeedbackModal(false);
									setShowAddFeedbackModal(true);
								}}
								onKeyDown={(e) => {
									if (e.key === "Enter" || e.key === " ") {
										setFeedbackPage(linkText);
										setShowFeedbackModal(false);
										setShowAddFeedbackModal(true);
									}
								}}
							>
								{linkText}
							</Button>
						))}
					</StyledWrapper>
				</Prompt>
			</StyledModal>
			<AddFeedbackModal
				showAddFeedbackModal={showAddFeedbackModal}
				setShowAddFeedbackModal={setShowAddFeedbackModal}
				sendFeedback={sendFeedback}
				feedbackText={feedbackText}
				setFeedbackText={setFeedbackText}
				sendFeedbackLoading={sendFeedbackLoading}
				setShowModalFromFloatingMenu={setShowModalFromFloatingMenu}
			/>
			<SrOnly role="status" aria-live="polite" aria-atomic="true">
				{toastMessage}
			</SrOnly>
			<Toast
				data-testid="message"
				text={toastMessage}
				isOpen={!!toastMessage}
				onCloseRequest={() => setToastMessage("")}
				ariaLabelCloseBtn="Dismiss notification"
			/>
		</>
	);
};

export default Layout;
